import React, { useRef } from "react";
import { Palette } from "lucide-react";

export default function CategoryBadgeColorPicker({ color, onChange, theme }) {
  const inputRef = useRef(null);

  return (
    <div className="relative inline-flex items-center">
      <button
        type="button"
        onClick={() => inputRef.current?.click()}
        className="p-1 rounded-full bg-white shadow border border-gray-200 text-gray-500 hover:text-blue-600 transition-colors"
        title={`Badge color (${theme} theme)`}
      >
        <Palette className="w-3 h-3" />
      </button>
      <div
        className="w-4 h-4 rounded-full border border-gray-200 shadow-sm ml-0.5"
        style={{ backgroundColor: color }}
      />
      <input
        ref={inputRef}
        type="color"
        value={color}
        onChange={(e) => onChange(e.target.value)}
        className="absolute opacity-0 inset-0 w-full h-full cursor-pointer"
      />
    </div>
  );
}